/**
 * The idea for this filter is to have a centralized list of all routes used in the front-end,
 * Using destructuring assignment and tree-shaking, we can only load those routes that we need
 * making sure that if the routes change in the future, we can easily update them in the front-end
 * without requiring changes in multiple places
 *
 * an example of how to load routes can be seen below:
 *
 * import { getTypeaheadOptions } from 'constants/routes'
 */

/*
 * Gets the value of the `href` attribute of the `base` element in the HTML document.
 * If the `base` element does not exist or does not have an `href` attribute, `baseElementUrl` will be `undefined`.
 *
 * Using document.querySelector('base').href could induce error in the code if the base element does not exist
 * or the href attribute is undefined, as it fallbacks to the document's fallback base URL, which is the current
 * Document's URL.
 */
const baseElementUrl = document.querySelector('base')?.attributes?.href?.value;

/*
 * Object that contains properties that can be useful for configuring the API requests
 * or other network requests in the application.
 */
const configuration = {
  baseUrl: baseElementUrl || window.location.origin,
};

export const getAdConfiguration = `${configuration.baseUrl}/ajax/getadconfiguration`;
export const getBreadcrumbContent = `${configuration.baseUrl}/ajax/getonpagebreadcrumb`;
export const getCommunitiesResults = `${configuration.baseUrl}/ajax/getResults`;
export const getHousingProductSnippetContent = `${configuration.baseUrl}/ajax/gethousingproductsnippetscontent`;
export const getListingCounts = `${configuration.baseUrl}/ajax/getResultCounts`;
export const getOnPageContent = `${configuration.baseUrl}/ajax/gethousingproductlocationcontentajax`;
export const getResultFacets = `${configuration.baseUrl}/ajax/getResultFacets`;
export const getTypeaheadOptions = `${configuration.baseUrl}/gettypeaheadoptions`;
export const leadsBasicCommunitySubmission = `${configuration.baseUrl}/ajax/leads/basiccommunitysubmission/`;
export const leadsBasicPlanSubmission = `${configuration.baseUrl}/ajax/leads/basicplansubmission/`;
export const leadsBasicSpecSubmission = `${configuration.baseUrl}/ajax/leads/basicspecsubmission/`;
export const leadsBasicListingSubmission = `${configuration.baseUrl}/ajax/leads/basiclistingsubmission/`;
export const leadsGetRecommendedCommunities = `${configuration.baseUrl}/ajax/leads/getrecommendedcommunities/`;
export const leadsPaidCommunitySubmission = `${configuration.baseUrl}/ajax/leads/paidcommunitysubmission/`;
export const leadsPaidPlanSubmission = `${configuration.baseUrl}/ajax/leads/paidplansubmission/`;
export const leadsPaidSpecSubmission = `${configuration.baseUrl}/ajax/leads/paidspecsubmission/`;
export const leadsRecommendedCommunitySubmission = `${configuration.baseUrl}/ajax/leads/recommendedcommunitysubmission/`;
export const mapGetCommunitiesPoints = `${configuration.baseUrl}/ajax/communities/getcommunitypoints`;
export const mapGetHomesPoints = `${configuration.baseUrl}/ajax/homes/gethomepoints`;
export const totalDeliveryValueCommunityLogger = `${configuration.baseUrl}/communitylogger`;
export const totalDeliveryValuePlanLogger = `${configuration.baseUrl}/planlogger`;
export const totalDeliveryValueSpecLogger = `${configuration.baseUrl}/speclogger`;
export const userDeleteFavorite = `${configuration.baseUrl}/user/deleteFavorite`;
export const userGetProfile = `${configuration.baseUrl}/getUserProfile`;
export const userProfileGetFavorites = `${configuration.baseUrl}/getUserFavorites`;
export const userSaveFavorite = `${configuration.baseUrl}/user/saveFavorite`;
export const marketingcampaignUnsubscribe = `${configuration.baseUrl}/marketingcampaign/unsubscribemarketingcampaign`;
export const marketingcampaignUnsubscribeFeedback = `${configuration.baseUrl}/marketingcampaign/unsubscribefeedback`;
export const googleOneTapLogin = `${configuration.baseUrl}/ajax/googleOneTapLogin`;
export const getCommunityNearbyListingsInfo = `${configuration.baseUrl}/ajax/getcommunitynearbylistings`;
export const getBuildablePlanNearbylistingsInfo = `${configuration.baseUrl}/ajax/getbuildableplannearbylistings`;
export const getPlanNearbyListingsInfo = `${configuration.baseUrl}/ajax/getplannearbylistings`;
export const getSpecNearbyListingsInfo = `${configuration.baseUrl}/ajax/getspecnearbylistings`;
export const listingCounts = `${configuration.baseUrl}/learn/dynamic/getlistingcounts`;
export const getArticleSuggestions = `${configuration.baseUrl}/learn/dynamic/getarticlesuggestions`;
export const getCommunitiesForYou = `${configuration.baseUrl}/learn/dynamic/getcommunitiesforyou`;
export const getHomesForYou = `${configuration.baseUrl}/learn/dynamic/gethomesforyou`;
export const getMetroSpecificArticles = `${configuration.baseUrl}/learn/dynamic/getmetroarearelatedarticles`;
export const getMostRecentArticles = `${configuration.baseUrl}/learn/dynamic/getmostrecentarticles`
export const blogRequestAccessToCacheManager = `${configuration.baseUrl}/util/blogcachemanager/requestaccess`;
export const deleteItemInAllServers = `${configuration.baseUrl}/util/cachemanager/deleteiteminallservers`;
export const purgeCdnCache = `${configuration.baseUrl}/util/purge-cdn-cache`;
export const learningCenter = `${configuration.baseUrl}/learn/`;
export const newsAndTrends = `${configuration.baseUrl}/news/`;
export const articleCards = `${configuration.baseUrl}/ajax/articles/cards/`;
export const articleSearchResults = `${configuration.baseUrl}/ajax/articles/search/`;
export const articleCountResults = `${configuration.baseUrl}/ajax/articles/counts/`;
export const searchCommunitySitePlans = `${configuration.baseUrl}/ajax/searchcommunitysiteplans`;
export const getCommunityInteractiveSitePlanMarkers = `${configuration.baseUrl}/ajax/getcommunityinteractivesiteplanmarkers`;
export const getCommunitySummaryCard = `${configuration.baseUrl}/ajax/getcommunitysummarycard`;
export const getHousingUnitSummaryCard = `${configuration.baseUrl}/ajax/gethousingunitsummarycard`;
export const getArticlesSuggestions = `${configuration.baseUrl}/ajax/articles/suggestions`;